import Vue from 'vue'
import App from './App.vue'
import router from '@/router'
import store from '@/store'
import '../theme/index.css'
import '@/theme/element-variables.scss'
import { Button, Input, Dropdown, DropdownMenu, DropdownItem, Upload, Card, Loading, MessageBox, Message, Dialog, Select, Option } from 'element-ui';
import PkDesignSystem from 'pickets-design-system'
import 'pickets-design-system/dist/system/system.css'
import 'pickets-design-system/dist/system/fonts/Gilroy.css';
import moment from 'moment'

Vue.filter('formatDate', function(value) {
  if (value) {
    return moment(String(value)).format('MM/DD/YYYY')
  }
});

Vue.use(PkDesignSystem)

Vue.use(Button)
Vue.use(Input)
Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Upload)
Vue.use(Dialog)
Vue.use(Card)
Vue.use(Select)
Vue.use(Option)
Vue.use(Loading.directive);

Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$message = Message;

Vue.config.productionTip = false

new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>'
})